// extracted by mini-css-extract-plugin
export default {"link":"BottomNav_link__GJ5AE","active":"BottomNav_active__vA+yk","content":"BottomNav_content__xk+OP","pages":"BottomNav_pages__JVSce"};